import { CircularProgress, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Shell from './layout/Shell'

export default function LoadingScreen({ label }) {
  const { t } = useTranslation()

  return (
    <Shell>
      <Stack minHeight="100vh" alignItems="center" justifyContent="center" spacing={2}>
        <CircularProgress />
        <Typography color="text.secondary">{label || t('loading.preparing')}</Typography>
      </Stack>
    </Shell>
  )
}
